import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import FrontNewsModuleTypes from '@/store/modules/frontDesk/news/interface';

const frontNewsModule: Module<FrontNewsModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        pageProjectList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/pageProjectList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        pageInformationList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/information/anon/pageInformationList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listActivityTag(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/information/anon/listActivityTag", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        getInformation(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/information/anon/getInformation", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        
    },
};

export default frontNewsModule;